"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * E-Verify Account Service
 * API for management of E-Verify Accounts
 *
 * The version of the OpenAPI document: 1.0.133
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountTypeToJSON = exports.AccountTypeFromJSONTyped = exports.AccountTypeFromJSON = exports.AccountType = void 0;
/**
 * The type of account. CORPORATE accounts have CHILD accounts. AGENCY accounts have CLIENT accounts. EMPLOYEE accounts are standalone. All but CORPORATE accounts can have cases associated to them.
 * @export
 * @enum {string}
 */
var AccountType;
(function (AccountType) {
    AccountType["CORPORATE"] = "CORPORATE";
    AccountType["AGENCY"] = "AGENCY";
    AccountType["EMPLOYER"] = "EMPLOYER";
    AccountType["CLIENT"] = "CLIENT";
    AccountType["CHILD"] = "CHILD";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
function AccountTypeFromJSON(json) {
    return AccountTypeFromJSONTyped(json, false);
}
exports.AccountTypeFromJSON = AccountTypeFromJSON;
function AccountTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AccountTypeFromJSONTyped = AccountTypeFromJSONTyped;
function AccountTypeToJSON(value) {
    return value;
}
exports.AccountTypeToJSON = AccountTypeToJSON;
